.potencySection {
  display: grid;
}

.header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 16px;
}

.title {
  font-size: 15px;
}

.slider {
  flex-direction: column;
  gap: 8px;

  p {
    font-size: 15px;
    margin-bottom: 0;
  }
}

.slider--hidden-values p {
  display: none;
}

@media all and (--reefer-media-tablet-min) {
  .potencySection {
    grid-template-columns: repeat(2, 1fr);
    gap: 32px;
  }

  .title {
    font-size: 20px;
  }

  .slider {
    flex-direction: column-reverse;
    gap: 16px;
  }
}
